export default {
  title: 'Historial de Actividades',

  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'menu.unproductives': 'Motivos de Improductividad',
  'menu.disapproves': 'Motivos de rechazo',
  'menu.canceled': 'Motivos de cancelación',
  'menu.pendencies': 'Motivos de Pendencia',
  'menu.newTrigger': 'Crear automatización',
  'menu.triggers': 'Automatizaciones',
  'menu.integrations': 'Integraciones',
  'menu.fields': 'Personalizar campos adicionales',
  'menu.templates': 'Plantillas de PDF',
  'menu.templateHistory': 'Historial de Documento',
  'counter.text': 'Registros encontrados',
  'menu.publicToken': 'Tokens públicos',
  'menu.semaphore': 'Configuración de semáforo',
  'menu.routines': 'Rutinas',
  'actions.viewPdf': 'Ver informe en PDF',
  'actions.copyLink': 'Copiar enlace público',
  'actions.linkCopied': '¡Enlace copiado!',
  'actions.linkCopyError': 'No se pudo copiar el enlace'
}
